import React from 'react';
import { connect, useSelector } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import TreatmentTypeDetails from './TreatmentTypeDetails';
import { jobDetailsForm } from '../../constants/FormConstants';

const TreatmentTypeDetailsContainer = (props) => {
  const { treatmentTypeDetails } = props;
  const formValues = useSelector((state)=>state.form.jobDetailsForm)//useSelector((state) => formValueSelector(jobDetailsForm)(state));
  const referenceData = useSelector((state) => state.referenceData);
  const sizeOfContainers =useSelector((state)=>state.referenceData.sizeOfContainers)
 /*const treatmentId = formValues.treatmentDetails&&
    formValues.treatmentDetails.treatmentTypeId || null;*/
      const clientDetails = useSelector((state) => state.clientDetails);
      const currentJob = useSelector((state) => state.currentJob);
    const treatmentId =  clientDetails != null && currentJob&&currentJob.treatmentDetails
    ? currentJob.treatmentDetails.treatmentTypeId
    : formValues.values.treatmentDetails.treatmentTypeId;


  return (
    <TreatmentTypeDetails
      {...props}
      customerCompletedChecked={formValues.values.customerCompleted}
      treatmentTypeDetails={treatmentTypeDetails}
      treatmentId={treatmentId}
      sizeOfContainers={sizeOfContainers}
      {...referenceData} // Spread reference data directly
    />
  );
};

export default connect()(TreatmentTypeDetailsContainer);
